document.addEventListener('DOMContentLoaded', function () {
  const COOKIE_NAME = 'cookie_consent';
  const COOKIE_EXPIRATION_DAYS = 365;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }

  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'wait_for_update': 500 
  });

  // Reaplicar consentimento salvo em visitas recorrentes
  const savedConsent = getCookie(COOKIE_NAME);
  if (savedConsent === 'granted_all') {
    gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });
  } else if (savedConsent === 'preferences_saved') {
    // Preferências foram salvas anteriormente — releitura dos checkboxes não é possível aqui,
    // mas como o cookie existe, aplicamos granted para analytics (mais conservador).
    // Para granularidade total, o cookie deveria armazenar as preferências individuais.
    gtag('consent', 'update', {
      'ad_storage': 'denied',
      'analytics_storage': 'granted'
    });
  }
  // Se 'denied_all', mantém o default (denied)

  const banner = document.getElementById('cookie-consent-banner');
  const acceptButton = document.getElementById('cookie-consent-accept');
  const denyButton = document.getElementById('cookie-consent-deny');
  const preferencesButton = document.getElementById('cookie-consent-preferences');
  const savePreferencesButton = document.getElementById('cookie-consent-save-preferences');
  const preferencesView = document.getElementById('cookie-consent-preferences-view');
  const mainContentView = document.querySelector('.cookie-consent-banner__content');
  const closePreferencesButton = document.getElementById('cookie-consent-preferences-close');

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  function showBanner() {
    banner.style.display = 'block';
  }

  function hideBanner() {
    banner.classList.add('cookie-consent-banner--hidden');
    setTimeout(() => {
        banner.style.display = 'none';
        banner.classList.remove('cookie-consent-banner--hidden');
    }, 300);
  }

  function updateConsent(consent) {
    gtag('consent', 'update', consent);
  }

  acceptButton.addEventListener('click', () => {
    const consent = {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    };
    updateConsent(consent);
    setCookie(COOKIE_NAME, 'granted_all', COOKIE_EXPIRATION_DAYS);
    hideBanner();
  });

  denyButton.addEventListener('click', () => {
    const consent = {
      'ad_storage': 'denied',
      'analytics_storage': 'denied'
    };
    updateConsent(consent);
    setCookie(COOKIE_NAME, 'denied_all', COOKIE_EXPIRATION_DAYS);
    hideBanner();
  });

  preferencesButton.addEventListener('click', () => {
    mainContentView.style.display = 'none';
    preferencesView.style.display = 'block';
  });

  closePreferencesButton.addEventListener('click', () => {
    preferencesView.style.display = 'none';
    mainContentView.style.display = 'block';
  });

  savePreferencesButton.addEventListener('click', () => {
    const analyticsCheckbox = document.getElementById('cookie-consent-analytics');
    const marketingCheckbox = document.getElementById('cookie-consent-marketing');

    const consent = {
      'analytics_storage': analyticsCheckbox.checked ? 'granted' : 'denied',
      'ad_storage': marketingCheckbox.checked ? 'granted' : 'denied'
    };

    updateConsent(consent);
    setCookie(COOKIE_NAME, 'preferences_saved', COOKIE_EXPIRATION_DAYS);
    hideBanner();
  });

  if (!getCookie(COOKIE_NAME)) {
    showBanner();
  }

  const managePreferencesLink = document.getElementById('manage-cookie-preferences');
  if (managePreferencesLink) {
    managePreferencesLink.addEventListener('click', function (event) {
      event.preventDefault();

      setCookie(COOKIE_NAME, '', -1);

      showBanner();
    });
  }
});
